import type { ModelEffortRule } from "../effort";
import { defineAIProviderManifest } from "../manifest";

// `max` (unconstrained thinking) is limited to the most capable Claude models.
// Unknown models match no rule and get no effort knob. Shared with the Bedrock
// (Anthropic) manifest, which serves the same Claude models.
export const ANTHROPIC_MODEL_EFFORTS: readonly ModelEffortRule[] = [
  { pattern: /fable|opus/i, levels: ["low", "medium", "high", "max"] },
  { pattern: /sonnet|haiku/i, levels: ["low", "medium", "high"] },
];

export const ANTHROPIC_CONTEXT_LIMIT_PATTERNS: readonly string[] = [
  "prompt is too long",
];

export const manifest = defineAIProviderManifest({
  id: "anthropic",
  label: "Anthropic",
  description: "Connect directly to Anthropic's API.",
  defaultBaseUrl: "https://api.anthropic.com",
  connectorIdentifier: "anthropic",
  endpointFromConnector: true,
  defaultChatModel: "claude-opus-5",
  defaultFastModel: "claude-haiku-4-5-20251001",
  defaultChatEffort: "low",
  modelEfforts: ANTHROPIC_MODEL_EFFORTS,
  configurable: true,
  requiresChatModel: false,
  reasoningReplay: { via: "signature", providerOptionsKey: "anthropic" },
  contextLimitPatterns: ANTHROPIC_CONTEXT_LIMIT_PATTERNS,
  credentialFields: [
    {
      key: "apiKey",
      label: "API key",
      description: "Stored securely on the server.",
      placeholder: "sk-ant-…",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: (v) => ({ baseUrl: "", apiKey: v.apiKey?.trim() ?? "" }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl, apiKey: "" }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    maxImageDimension: 2000,
  },
});
